<main class="Siarty siarty__auction-details">
  <section class="auction-details__bodyMain">
    <div class="auction-details__bodyOuter">
      <div class="auction-details__cards">
        <div
          class="auction-details__cardwrapper"
          *ngFor="let item of allTodaysLiveProductList"
        >
          <div
            class="auction-details__BodyCard"
            routerLink="/auction-details"
            (click)="editAuction(item['auctionId'], false, item['productid'])"
          >
            <div class="auction-details__cardImg">
              <img
                *ngIf="item['image']"
                class="card-img-top"
                [src]="item['image']"
                alt="Card image cap"
              />
              <img
                *ngIf="!item['image']"
                class="card-img-top"
                src="/assets/img/user-placeholder.png"
                alt="Card image cap"
              />
            </div>
            <div class="auction-details__CardBody p-2">
              <div class="auction-details__cardAutionTime">
                <h5 class="card-title auction-details__cardTitle">
                  {{ item["carName"] }}
                </h5>
              </div>

              <div
                class="auction-details__liveBtnGroup p-2 w-100"
                *ngIf="item['auction_status_id'] === null"
              >
                <div class="auction-details__liveBtnIndicator mx-2"></div>
                <button
                  type="submit"
                  class="auction-details__liveBtn"
                  id="second"
                >
                  Live
                </button>
              </div>

              <div
                class="auction-details__liveBtnGroup p-2 w-100"
                *ngIf="item['auction_status_id'] === '1'"
              >
                <div class="auction-details__closedBtnIndicator mx-2"></div>
                <button
                  type="submit"
                  class="auction-details__closedBtn"
                  id="second"
                >
                  Closed
                </button>
              </div>

              <div class="auction-details__cardDescription">
                <div class="container">
                  <div class="row">
                    <div class="col-5 col-sm-5 col-sm-5">
                      <ul class="list-unstyled">
                        <li class="auction-details__listKeys">Buy now</li>
                        <!-- <li class="auction-details__listKeys">
                            financing from
                          </li>
                          <li class="auction-details__listKeys">
                            Current pre-bid
                          </li> -->
                      </ul>
                    </div>
                    <div class="col-6 col-sm-6 col-6">
                      <ul class="list-unstyled">
                        <li class="auction-details__listValues">
                          SAR
                          {{ item["buyNowPrice"] ? item["buyNowPrice"] : "--" }}
                        </li>
                        <!-- <li class="auction-details__listValues">
                            SAR 300/month
                          </li>
                          <li class="auction-details__listValues">
                            SAR
                            {{
                              item["currentPreBid"] ? item["currentPreBid"] : "--"
                            }}
                          </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="auction-details__cardwrapper"
          *ngFor="let item of allTodaysInitialLiveProductList"
        >
          <div
            class="auction-details__BodyCard"
            routerLink="/auction-details"
            (click)="editAuction(item['auctionId'], true, item['productid'])"
          >
            <div class="auction-details__cardImg">
              <img
                class="card-img-top"
                [src]="item['image']"
                alt="Card image cap"
              />
            </div>
            <div class="auction-details__CardBody p-2">
              <div class="auction-details__cardAutionTime">
                <h5 class="card-title auction-details__cardTitle">
                  {{ item["carName"] }}
                </h5>
              </div>

              <div class="auction-details__liveBtnGroup p-2">
                <div
                  class="auction-details__initialLiveBtnIndicator mx-2"
                ></div>
                <button
                  type="submit"
                  class="auction-details__initialLiveBtn"
                  id="third"
                >
                  Auction Start
                </button>
              </div>

              <div class="auction-details__cardDescription">
                <div class="container">
                  <div class="row">
                    <div class="col-5 col-sm-5 col-sm-5">
                      <ul class="list-unstyled">
                        <li class="auction-details__listKeys">Buy now</li>
                        <!-- <li class="auction-details__listKeys">
                            financing from
                          </li>
                          <li class="auction-details__listKeys">
                            Current pre-bid
                          </li> -->
                      </ul>
                    </div>
                    <div class="col-6 col-sm-6 col-6">
                      <ul class="list-unstyled">
                        <li class="auction-details__listValues">
                          SAR
                          {{ item["buyNowPrice"] ? item["buyNowPrice"] : "--" }}
                        </li>
                        <!-- <li class="auction-details__listValues">
                            SAR 300/month
                          </li>
                          <li class="auction-details__listValues">
                            SAR
                            {{
                              item["currentPreBid"] ? item["currentPreBid"] : "--"
                            }}
                          </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="auction-details__cardwrapper"
          *ngFor="let item of allBulkTodaysLiveProductList"
        >
          <div
            class="auction-details__BodyCard"
            routerLink="/auction-details"
            (click)="
              editBulkAuction(
                item['auctionId'],
                false,
                item['productid'],
                item['productinfo']
              )
            "
          >
            <div class="auction-details__cardImg">
              <img
                class="card-img-top"
                [src]="item['image']"
                alt="Card image cap"
              />
            </div>
            <div class="auction-details__CardBody p-2">
              <div class="auction-details__cardAutionTime">
                <h5 class="card-title auction-details__cardTitle">
                  {{ item["carName"] }}
                </h5>
              </div>

              <div
                class="auction-details__liveBtnGroup p-2"
                *ngIf="item['auction_status_id'] === null"
              >
                <div class="auction-details__liveBtnIndicator mx-2"></div>
                <button
                  type="submit"
                  class="auction-details__liveBtn"
                  id="second"
                >
                  Live
                </button>
              </div>

              <div
                class="auction-details__liveBtnGroup p-2"
                *ngIf="item['auction_status_id'] === '1'"
              >
                <div class="auction-details__closedBtnIndicator mx-2"></div>
                <button
                  type="submit"
                  class="auction-details__closedBtn"
                  id="second"
                >
                  Closed
                </button>
              </div>

              <div class="auction-details__cardDescription">
                <div class="container">
                  <div class="row">
                    <div class="col-5 col-sm-5 col-sm-5">
                      <ul class="list-unstyled">
                        <li
                          class="auction-details__listKeys"
                          *ngIf="item['auctionType'] === '1'"
                        >
                          No. of batch
                        </li>
                        <li
                          class="auction-details__listKeys"
                          *ngIf="item['auctionType'] === '0'"
                        >
                          No. of car
                        </li>
                        <!-- <li class="auction-details__listKeys">
                            financing from
                          </li>
                          <li class="auction-details__listKeys">
                            Current pre-bid
                          </li> -->
                      </ul>
                    </div>
                    <div class="col-6 col-sm-6 col-6">
                      <ul class="list-unstyled">
                        <li class="auction-details__listValues">
                          {{ item["productid"] }}
                        </li>
                        <!-- <li class="auction-details__listValues">
                            SAR 300/month
                          </li>
                          <li class="auction-details__listValues">
                            SAR
                            {{
                              item["currentPreBid"] ? item["currentPreBid"] : "--"
                            }}
                          </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="auction-details__cardwrapper"
          *ngFor="let item of allBulkTodaysInitialLiveProductList"
        >
          <div
            class="auction-details__BodyCard"
            routerLink="/auction-details"
            (click)="
              editBulkAuction(
                item['auctionId'],
                true,
                item['productid'],
                item['productinfo']
              )
            "
          >
            <div class="auction-details__cardImg">
              <img
                class="card-img-top"
                [src]="item['image']"
                alt="Card image cap"
              />
            </div>
            <div class="auction-details__CardBody p-2">
              <div class="auction-details__cardAutionTime">
                <h5 class="card-title auction-details__cardTitle">
                  {{ item["carName"] }}
                </h5>
              </div>

              <div class="auction-details__liveBtnGroup p-2">
                <div
                  class="auction-details__initialLiveBtnIndicator mx-2"
                ></div>
                <button
                  type="submit"
                  class="auction-details__initialLiveBtn"
                  id="third"
                >
                  Auction Start
                </button>
              </div>

              <div class="auction-details__cardDescription">
                <div class="container">
                  <div class="row">
                    <div class="col-5 col-sm-5 col-sm-5">
                      <ul class="list-unstyled">
                        <li
                          class="auction-details__listKeys"
                          *ngIf="item['auctionType'] === '1'"
                        >
                          No. of batch
                        </li>
                        <li
                          class="auction-details__listKeys"
                          *ngIf="item['auctionType'] === '0'"
                        >
                          No. of car
                        </li>
                        <!-- <li class="auction-details__listKeys">
                            financing from
                          </li>
                          <li class="auction-details__listKeys">
                            Current pre-bid
                          </li> -->
                      </ul>
                    </div>
                    <div class="col-6 col-sm-6 col-6">
                      <ul class="list-unstyled">
                        <li class="auction-details__listValues">
                          {{ item["productid"] }}
                        </li>
                        <!-- <li class="auction-details__listValues">
                            SAR 300/month
                          </li>
                          <li class="auction-details__listValues">
                            SAR
                            {{
                              item["currentPreBid"] ? item["currentPreBid"] : "--"
                            }}
                          </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div *ngFor="let item of todayFutureProductList">
                      <div class="auction-details__BodyCard" routerLink="/auction-details"
                          (click)="editAuction(item['auctionId'], false,item['productid'])">
                          <div class="auction-details__cardImg">
                              <img class="card-img-top" [src]="item['image']" alt="Card image cap">
                          </div>
                          <div class="auction-details__CardBody p-2">
                              <div class="auction-details__cardAutionTime">
                                  <h5 class="card-title auction-details__cardTitle"> {{item['carName']}} </h5>
                                  <span class="auction-details__listDesKeys"> Auction starts </span>
                                  <span class="auction-details__listDesValues ml-1"> {{item['auctionStartTime']}} </span>
                              </div>
  
                              <div class="auction-details__cardDescription">
                                  <div class="container">
                                      <div class="row">
                                          <div class="col-5 col-sm-5 col-sm-5">
                                              <ul class="list-unstyled">
                                                  <li class="auction-details__listKeys"> Buy now </li>
                                                  <li class="auction-details__listKeys"> financing from </li>
                                                  <li class="auction-details__listKeys"> Current pre-bid </li>
                                              </ul>
                                          </div>
                                          <div class="col-6 col-sm-6 col-6">
                                              <ul class="list-unstyled">
                                                  <li class="auction-details__listValues">SAR {{item['buyNowPrice'] ?
                                                      item['buyNowPrice'] : '--'}}</li>
                                                  <li class="auction-details__listValues">SAR 300/month</li>
                                                  <li class="auction-details__listValues">SAR {{item['currentPreBid'] ?
                                                      item['currentPreBid'] : '--'}}</li>
                                              </ul>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div> -->
      </div>
    </div>
  </section>
</main>

<app-loader *ngIf="loading"></app-loader>
